import React from 'react'

export default function renderDateGroupListHeader(id, props) {
    const classes = Classes('gd-field-date-group-list-header', props.className)

    return (
        <div className={classes}>
            <div className="group-list-header-value">
                {props.data.name}
            </div>
        </div>
    );
}